"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageFour = void 0;
exports.pageFour = () => ({
    content: [
        {
            margin: [0, 0, 0, 20],
            layout: 'noBorders',
            table: {
                widths: [120, 120],
                headerRows: 1,
                body: [
                    [
                        {
                            stack: [
                                'Abbie A',
                                'a, a SC 92068',
                                'DOB: 08/22/2018',
                                'Gender: Female',
                            ],
                            fontSize: 8,
                        },
                        { image: 'barcodeImage.png', width: 75 },
                    ],
                ],
            },
        },
        { text: 'Patient Medication Waiver', fontSize: 16, alignment: 'center' },
        {
            style: 'tableText',
            stack: [
                'In keeping with our mission to deliver quality, convenient, patient-centered care, ' +
                    'Palmetto Physical Meidcine (Anderson) offers its patients in-officedispensing of select ' +
                    'medications. Doing so will better ensure you receive your medication as quickly and ' +
                    'cost-effectively as possible so treatment can start right away.',
                {
                    text: 'If you decide to fill your prescription at another pharmacy, your decision will in ' +
                        'no way affect the medical care you receive from our health care professionals.',
                    margin: [0, 10, 0, 10],
                },
                {
                    text: 'I hereby acknowledge reading and understanding the above information provided for the ' +
                        'in-office dispensing program and have been given to opportunity to ask questions and wish ' +
                        'to obtain my prescription from Pharmacy Name.',
                    bold: true,
                    margin: [0, 0, 0, 50],
                },
            ],
        },
        { text: 'Patient Signature: _________________________  Date: _______________', alignment: 'left' },
    ],
    styles: {
        tableText: {
            fontSize: 8,
            bold: false,
            margin: [-20, 15, 0, 0],
            alignment: 'left',
        },
        notice: {
            fontSize: 8,
            margin: [50, 30, 0, 0],
            alignment: 'center',
        },
        barcode: {
            alignment: 'center',
        },
    },
});



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/pdfs/fourthPage.ts
// module id = 2729
// module chunks = 0 1